import { render, staticRenderFns } from "./Lobby.component.html?vue&type=template&id=279f00de&"
import script from "./Lobby.component.ts?vue&type=script&lang=ts&"
export * from "./Lobby.component.ts?vue&type=script&lang=ts&"
import style0 from "./Lobby.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports